import React from "react";
import "../App.css";
import TutorialPageDisplay from "../components/TutorialPage/TutorialPageDisplay";

const Tutorial = () => {
  return (
    <div className="App">
      <header className="App-header">
        <TutorialPageDisplay />
      </header>
    </div>
  );
};
export default Tutorial;
